(function () {
  const root = document.querySelector(".nlp-info-strip");
  if (!root || root.dataset.init === "1") return;
  root.dataset.init = "1";

  const gsap = window.gsap;
  if (!gsap) return;

  const prefersReduced =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (prefersReduced) return;

  if (window.ScrollTrigger) gsap.registerPlugin(window.ScrollTrigger);

  const items = Array.from(root.querySelectorAll(".nlp-info-strip__item"));
  if (!items.length) return;

  gsap.set(items, { opacity: 0, y: 16 });

  gsap.to(items, {
    opacity: 1,
    y: 0,
    duration: 0.7,
    ease: "power2.out",
    stagger: 0.06,
    scrollTrigger: window.ScrollTrigger
      ? { trigger: root, start: "top 85%", once: true }
      : undefined,
  });
})();
